export default __webpack_public_path__ + "45b1185ec976df7442ff6e0d476d2d0e.png";